import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const StorePage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Store,
  }))
);

export function StoreContainer() {
  return <LazyLoadComponent Component={<StorePage />} />;
}
